import axios from '@/components/api/axios';

async function search(zipCode) {
  let data = {
    zipCode: zipCode
  }
  const res = await axios.axiosGet('/api/zipCode/search', data);
  return res;
}

export default {
  search
}



// WEBPACK FOOTER //
// ./src/components/api/zip.js